import BusinessPage from './BusinessPage'

export default BusinessPage;